import theme from '../../../../../lib/theme';
import { ExplainerBlockProps } from './ExplainerBlock';

const { scale, layouts, media, colors } = theme;

export default ({
  block: { backgroundColor = 'transparent' },
}: ExplainerBlockProps) => ({
  panel: {
    ...layouts.column,

    backgroundColor: colors[backgroundColor] || colors.sas[backgroundColor],
    alignItems: 'center',
    padding: `${scale.m} ${scale.xs} ${scale.xl}`,
    maxWidth: '100vw',
    overflow: 'hidden',
  },

  container: {
    ...layouts.container('l'),
    ...layouts.spacedColumn('l'),
  },

  headings: {
    ...layouts.spacedColumn('xs'),

    width: '100%',
    maxWidth: 903,
  },

  products: {
    ...layouts.spacedColumn('s'),

    flexWrap: 'wrap',
    alignItems: 'center',

    '& > *': {
      marginRight: scale.xs,
      marginBottom: scale.m,
    },

    [media.m.up]: {
      ...layouts.row,

      alignItems: 'stretch',
    },

    [media.l.up]: {
      '& > *': {
        marginRight: scale.s,
        marginBottom: scale.m,
      },
    },
  },
});
